var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-complete"},[_c('div',[_vm._v(_vm._s(_vm.examName))]),_c('Button',{staticStyle:{"margin-bottom":".2rem","padding":".2rem","height":"auto"},attrs:{"type":"success"},on:{"click":_vm.completed}},[_vm._v("完成 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }